import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';
import { Collapse } from '@mui/material';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('HypotheticalInvestmentDisclaimer', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  readMore: {
    textDecoration: 'underline',
  },
  disclaimersLinkContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(1),
  },
  disclaimersLink: {
    fontSize: theme.typography.fontSizePt75Rem,
    color: theme.palette.facet.primaryGray,
    margin: theme.spacing(0, 0.5),
    fontWeight: theme.typography.fontWeightBold,
  },
  disclaimerText: {
    color: theme.palette.facet.mediumDarkGray,
    weight: theme.typography.fontWeightFacetBook,
    fontSize: theme.typography.fontSizePt75Rem,
    '& a': {
      color: theme.palette.facet.primaryGray,
    },
  },
}));

const CollapsibleDisclaimer = ({
  className,
  disclaimerTitle,
  disclaimerText,
  disclaimerReadMore,
}) => {
  const [showReadMore, setShowReadMore] = useState(false);
  const theme = useTheme();
  const classes = useStyles(theme);

  const toggleReadMore = () => setShowReadMore(!showReadMore);

  return (
    <Box
      className={classNames(classes.root, className)}
      {...dataAttrs('collapsible-disclaimer')}
    >
      <Text
        align={'left'}
        variant={'h6'}
        color={'primaryGray'}
        text={disclaimerTitle}
      />
      <RichTextDisplay
        className={classes.disclaimerText}
        content={disclaimerText}
      />
      {disclaimerReadMore && (
        <>
          <Collapse in={showReadMore} timeout={'auto'}>
            <div>
              <RichTextDisplay
                className={classes.disclaimerText}
                content={disclaimerReadMore}
              />
            </div>
          </Collapse>
          <Button1
            onClick={toggleReadMore}
          >
            <Text
              className={classNames(classes.readMore)}
              variant={'body'}
              weight={'medium'}
              color={'primaryGray'}
              text={showReadMore ? 'Read Less' : 'Read More'}
            />
          </Button1>
        </>
      )}
    </Box>
  );
};

CollapsibleDisclaimer.defaultProps = {
  className: '',
  disclaimerTitle: '',
  disclaimerReadMore: undefined,
};

CollapsibleDisclaimer.propTypes = {
  className: PropTypes.string,
  disclaimerTitle: PropTypes.string,
  disclaimerText: PropTypes.string.isRequired,
  disclaimerReadMore: PropTypes.string,
};

export default CollapsibleDisclaimer;
